<div class="date-range-container">
    <form [formGroup]="dateFilterForm">
        <mat-form-field appearance="fill" [dir]="'rtl'" class="date-range date-field" [ngClass]="{ error: invalidEndDateError }" (click)="picker.open()">
            <span *ngIf="noDateSelected" class="all-days-text">
                {{ 'allDays' | translate }}
            </span>
            <mat-date-range-input [rangePicker]="picker" [hidden]="noDateSelected" [max]="maxDate">
                <input matStartDate formControlName="startDateFormControl" placeholder="{{ 'startDate' | translate }}" readonly />
                <input matEndDate formControlName="endDateFormControl" placeholder="{{ 'endDate' | translate }}" readonly />
            </mat-date-range-input>
            <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
            <span matPrefix class="divider"> </span>
            <mat-date-range-picker
                #picker
                (closed)="onDatepickerClose()"
                (opened)="onDatepickerOpen()"
                [calendarHeaderComponent]="customHeader"
            ></mat-date-range-picker>
            <mat-hint class="hint-as-error" *ngIf="invalidEndDateError">
                {{ 'pleaseSelectAnEndDate' | translate }}
            </mat-hint>
        </mat-form-field>
        <div style="display: none">
            <div class="date-picker-footer" #datepickerFooter>
                <button mat-raised-button class="all-days-btn" (click)="onAllDaysBtnClick()">
                    {{ 'allDays' | translate }}
                </button>
            </div>
        </div>
    </form>
</div>
